import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../reducers';
import { ButtonBackWrapper } from './styles';
import { ButtonBack } from '../styles';
import MainView from './MainView';
import ResourceSelector from '../../../../containers/ResourceSelector';
import { ResourceSelectorTheme } from '../../../ResourceSelector';
import { FileType, removeFileFromImport } from '../../../../containers/ImportManager/actions';
import Utils from '../../../../utils';
import { Api } from '../../../../typings/api';
import { StyleColor } from '../../../../utils/styles-constants';

interface ResourcePanelProps {
	iconName: string;
	label: string;
	importManagerId: string;
	isImporting: boolean;
	isResetButtonDisplayed: boolean;
	dispatch: Dispatch<StoreState>;
	onResourceSelect: (driveItem: Api.DriveItem) => void;
	onResourceReset?: () => void;
	isExternalLinkActive?: boolean;
	linkPanel?: React.ReactNode;
	isValidResourceFromApp?: (item: Api.DriveItem) => boolean;
	fileExtensions?: string[];
	isFileExtensionsDisplayed?: boolean;
	isOptimizedImageImport?: boolean;
	fileType?: FileType;
}

let isMounted = false;

const ResourcePanel = ({
	iconName,
	label,
	importManagerId,
	isImporting,
	isResetButtonDisplayed,
	dispatch,
	onResourceSelect,
	onResourceReset,
	isExternalLinkActive,
	linkPanel,
	isValidResourceFromApp = () => true,
	fileExtensions,
	isFileExtensionsDisplayed,
	isOptimizedImageImport,
	fileType,
}: ResourcePanelProps) => {
	const [isResourceSelectorDisplayed, setIsResourceSelectorDisplayed] = React.useState(isImporting);

	const handleResourceSelect = (driveItem: Api.DriveItem): void => {
		onResourceSelect(driveItem);

		const { status } = driveItem;
		const isProcessing = status && status !== Api.AssetItemStatus.LIVE;

		// do not update state on unmounted component to avoid memory leaks
		if (isMounted && !isProcessing) {
			setIsResourceSelectorDisplayed(false);
		}
	};

	const handleResourceReset = (): void => {
		if (isImporting) {
			dispatch(removeFileFromImport(importManagerId));
		}

		if (onResourceReset) {
			onResourceReset();
		}
	};

	React.useEffect(() => {
		isMounted = true;
		return () => {
			isMounted = false;
		};
	}, []);

	React.useEffect(() => {
		setIsResourceSelectorDisplayed(isImporting);
	}, [isImporting]);

	return (
		<>
			{!isResourceSelectorDisplayed
				? (
					<MainView
						iconName={iconName}
						label={label}
						linkPanel={linkPanel}
						isExternalLinkActive={isExternalLinkActive}
						isResetButtonDisplayed={isResetButtonDisplayed}
						onReplaceClick={() => setIsResourceSelectorDisplayed(true)}
						onResetClick={handleResourceReset}
					/>
				)
				: (
					<>
						<ButtonBackWrapper>
							<ButtonBack
								type="button"
								onClick={() => setIsResourceSelectorDisplayed(false)}
							>
								{Utils.getSvgIcon('iconset_back')}
								<Translate value="messages.back" />
							</ButtonBack>
						</ButtonBackWrapper>
						<ResourceSelector
							id={importManagerId}
							label="messages.replace_file"
							isValidResourceFromApp={isValidResourceFromApp}
							fileExtensions={fileExtensions}
							isFileExtensionsDisplayed={isFileExtensionsDisplayed}
							isOptimizedImageImport={isOptimizedImageImport}
							isPublicationDependency={true}
							fileType={fileType}
							linkPanel={linkPanel}
							onSelect={([item]) => handleResourceSelect(item)}
							actionButtonColor={StyleColor.Blue600}
							theme={ResourceSelectorTheme.DARK}
						/>
					</>
				)
			}
		</>
	);
};

export default ResourcePanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ResourcePanel/index.tsx